import {instance} from '@/api';
import {authApi} from '@/api';
import {userApi} from '@/api';
import moment from 'moment-timezone';
import Vue from 'vue';

const default_user = {
	balance: 0,
	sevenToken: null
}

export default {
	state: {
		sessionStart: null,
		sessionTime: '',
		loggedIn: false,
		user: default_user,
		details: {

		},
		bets: {
			from: '',
			to: '',
			limit: '',
			list: []
		},
		transactions: {
			params: {
				loading: false,
				page: 0,
				total_pages: 0,
				total_transactions: 0,
			},
			data: null
		},
		paymentTypes: []


	},
	mutations: {
		setUser(state, data) {
			if(!state.loggedIn){
				state.sessionStart = new Date();

			}
			//Check if we have same user
			if(data.id){

				state.loggedIn = true;
				Vue.set(state, 'user', Object.assign({}, state.user, data));
			}




			//state.user = data;
		},
		setDetails(state, data) {
			state.details = data;
		},
		setBalance(state, data) {

			if(state.user.id){
				state.user.balance = data;
			}
		},
		clearUser(state) {
			state.sessionStart = null;
			state.loggedIn = false;
			state.user = Object.assign({}, default_user);
			state.details = {};
			state.transactions.data = null;
			state.bets.list = [];
		},
		checkUser(state){
			if(!state.user.id){
				this.dispatch('userDataAction');
			}

		},

		setUserBetsFrom(state, date){
			date = moment(date).format('YYYY-MM-DD');
			if(state.bets.from !== date){
				state.bets.from = date;
				this.dispatch('getUserBets');
			}

		},
		setUserBetsTo(state, date){
			date = moment(date).format('YYYY-MM-DD');
			if(state.bets.to !== date){
				state.bets.to = date;
				this.dispatch('getUserBets');
			}


		},
		setUserBetsFromTo(state, dates){

			let from = dates.from === '' ? '' : moment(dates.from).format('YYYY-MM-DD');
			let to = dates.to === '' ? '' : moment(dates.to).format('YYYY-MM-DD');

			/*if( (dates.from === '' && dates.to === '') || (state.bets.to !== to || state.bets.from !== from) ){
				state.bets.from = from;
				state.bets.to = to;
				state.bets.limit = dates.limit;
				this.dispatch('getUserBets');
			}*/

			//Always update
			state.bets.from = from;
			state.bets.to = to;
			state.bets.limit = dates.limit;
			this.dispatch('getUserBets');
		},


		setTransactionsParams(state, params){

			//Merge request parameters

			/*if(obj['page_number'] === ''){
				delete obj['page_number'];
			}*/

			state.transactions.params = Object.assign({}, state.transactions.params, params );
			state.transactions.params.loading = true;
			this.dispatch('getUserTransactions');

		},
		setSessionTime(state, val){
			state.sessionTime = val;
		},



		gotBets(state, data){

			if(data.status === 'SUCCESS'){
				state.bets.list = data.content.user;
			}
		},

		gotTransactions(state, data){

			if(data.status === 'SUCCESS' && data.content && data.content.list){



				state.transactions.params.loading = false;
				state.transactions.data = data.content.list.transactions;


				state.transactions.params['page'] = data.content.list['page'];
				state.transactions.params['total_pages'] = data.content.list['total_pages'];
				state.transactions.params['total_transactions'] = data.content.list['total_transactions'];
			}
		},
		gotPaymentTypes(state, data){
			state.paymentTypes = data;
		}

	},

	getters: {
		getUser(state) {
			return state.user;
		},
		getUserDetails(state) {
			return state.details;
		},
		getUserStatus(state) {
			return state.loggedIn;
		},



		getBets(state){


			return state.bets.list.slice().filter((el)=>{
				//Filter dates, with check id dates limits is set
				return state.bets.from === '' ? true : moment(el.meetdate).isSameOrAfter(state.bets.from)
					&& state.bets.to === '' ? true : moment(el.meetdate).isSameOrBefore(state.bets.to)
			});
		},
		getTransactions(state){
			//Fail safe getter
			return state.transactions.data
					?
					state.transactions.data
					:
					[];
		},
		getTransactionsParams(state){
			return state.transactions.params;
		},
		getSessionTime(state){
			return state.sessionTime;
		},
		getPaymentTypes(state){
			return state.paymentTypes;
		}
	},
	actions: {
		updateSessionTime({state, commit}) {
			if(state.sessionStart){
				let x = moment();
				let y = moment(state.sessionStart);
				let duration = moment.duration(x.diff(y));

				let text = '';
				if (duration._data ) {

					if(duration._data.years > 0){
						text+= duration._data.years+':';
					}
					if(duration._data.months > 0){
						text+= duration._data.months > 9 ? duration._data.months+':' : '0'+duration._data.months+':';
					}
					if(duration._data.hours >= 0){
						text+= duration._data.hours > 9 ? duration._data.hours+':' : '0'+duration._data.hours+':';
					}
					if(duration._data.minutes >= 0){
						text+=  duration._data.minutes > 9 ? duration._data.minutes+':' : '0'+duration._data.minutes+':';
					}
					if(duration._data.seconds >= 0){
						text+= duration._data.seconds > 9 ? duration._data.seconds : '0'+duration._data.seconds;
					}
					commit('setSessionTime', text);
					return;
				}

			}
			commit('setSessionTime', '00:00:00');
		},
		userRefreshAction({commit}) {
			return instance.get(authApi.refresh+ '?timestamp='+new Date().valueOf())
				.then((responce) => {

					if (responce.data && responce.data.status) {

						if (responce.data.status === 'SUCCESS' && responce.data.login) {

							if(responce.data.content.customer_data && responce.data.content.customer_data.id){
								commit('setUser', responce.data.content['customer_data']);
							}else{
								commit('setBalance', responce.data.content['balance']);
								commit('checkUser');
							}

						} else if (responce.data && !responce.data.login) {
							commit('clearUser');
						}
					} else {
						console.warn('User refresh network error');
					}
					Promise.resolve(responce);

				}).catch((er) => {
					commit('clearUser');
					console.warn(er);
					Promise.reject(er)
				});
		},
		userDataAction({commit}) {
			return instance.get(authApi.data)
				.then((responce) => {

					if (responce.data && responce.data.status) {

						if (responce.data.status === 'SUCCESS' && typeof responce.data.content['customer_data'].id !== 'undefined') {
							commit('setUser', responce.data.content['customer_data']);
							commit('setDetails', responce.data.content['customer_payment_account']);
						} else if (responce.data.status === 'SUCCESS') {
							commit('clearUser');
						}
					} else {
						console.warn('User DATA network error');
					}
					Promise.resolve(responce);

				}).catch((er) => {
					console.warn(er);
					Promise.reject(er)
				});
		},

		/**
		 * Logout user, and clear user data action
		 * */
		userLogoutAction({commit}) {

			return instance.get(authApi.logout)
				.then((responce) => {
					if (responce.data && responce.data.status && responce.data.status !== 'ERROR') {
						commit('clearUser');
					} else {
						console.warn('User LOGOUT network error');
					}
				}).catch((er) => {
					console.warn(er);
				});
		},
		async getUserBets({state, commit}){
			const {data} = await instance.post(userApi.bets, {
				fromdate: state.bets.from,
				todate: state.bets.to,
				limit: state.bets.limit
			});

			commit ('gotBets', data);
		},
		async getUserTransactions({state, commit}){

			//Fucking rest date validation
			let obj = Object.assign({}, state.transactions.params);

			if(obj['date_from'] === ''){
				delete obj['date_from'];
			}
			if(obj['date_to'] === ''){
				delete obj['date_to'];
			}

			const {data} = await instance.post(userApi.transactions, obj);

			commit ('gotTransactions', data);
		},



		/**
		 * User data change actions
		 * */
		saveUserData({commit}, data){

			return instance.put(userApi.data, data)
				.then((responce) => {
					if (responce.data && responce.data.status && responce.data.status !== 'ERROR') {
						commit('setUser', responce.data.content['customer_data']);

						if(responce.data.content['customer_payment_account']){
							commit('setDetails', responce.data.content['customer_payment_account']);
						}
					}
					return responce;
				}).catch((er) => {
					console.warn(er);
				});
		},

		requestSelfExlude({commit}){


			return instance.post(userApi.exclude).then((responce)=>{
				if (responce.data && responce.data.status && responce.data.status !== 'ERROR') {
					commit('clearUser');
				}
				return responce;
			})
		},

		getUserPayinOptions({commit}){
			return instance.post(userApi.paymentTypes).then((responce)=>{
				if (responce.data && typeof responce.data.error === 'undefined' ) {
					commit('gotPaymentTypes', responce.data.content);
				}
				return responce;
			})
		}
	}
}
